import {CSSProperties, FC} from 'react';


export interface IIconSpecVehiclesProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSpecVehicles: FC<IIconSpecVehiclesProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m20.885 11.71-2.747-3.799a.703.703 0 0 0-.588-.317H14v-1.89A.703.703 0 0 0 13.297 5H3.703A.703.703 0 0 0 3 5.703v10.188c0 .388.315.703.703.703h2.23A2.113 2.113 0 0 0 7.922 18c.917 0 1.698-.588 1.988-1.406h4.965A2.113 2.113 0 0 0 16.864 18c.916 0 1.698-.588 1.988-1.406h1.445A.703.703 0 0 0 21 15.89v-3.795a.703.703 0 0 0-.115-.386ZM7.922 16.594a.704.704 0 1 1 .002-1.408.704.704 0 0 1-.002 1.408Zm4.672-1.407H9.91a2.113 2.113 0 0 0-1.988-1.406c-.917 0-1.698.588-1.989 1.406H4.406v-8.78h8.188v8.78Zm4.27 1.407a.704.704 0 1 1 .002-1.408.704.704 0 0 1-.002 1.408Zm2.73-1.407h-.742a2.113 2.113 0 0 0-1.988-1.406c-.917 0-1.698.588-1.989 1.406H14V9h3.17l2.424 3.306v2.882Z" />
        </svg>
    );
};
